import { Controller } from "@hotwired/stimulus"

/*
This is part of the implementation of the Clients::ToggleComponent and probably won't serve any
purpose outside of that context
*/
export default class extends Controller {
  static targets = ["checkbox", "checkedLabel", "uncheckedLabel"];

  connect() {
    if (!this.hasCheckboxTarget)
      throw new Error("No checkbox target found");

    if (!this.hasCheckedLabelTarget)
      throw new Error("No checkedLabel target found");
      
    if (!this.hasUncheckedLabelTarget)
      throw new Error("No uncheckedLabel target found");

    this.update();
    this.checkboxTarget.addEventListener("change", () => {
      this.update();
    })
  }

  update() {
    this.checkedLabelTarget.classList.toggle("font-bold", this.checkboxTarget.checked);
    this.checkedLabelTarget.classList.toggle("text-forest", this.checkboxTarget.checked);
    this.uncheckedLabelTarget.classList.toggle("font-bold", !this.checkboxTarget.checked);
    this.uncheckedLabelTarget.classList.toggle("text-charcoal-75", !this.checkboxTarget.checked);
  }
}